<zag-card [variant]="cardVariant()" (cardClick)="onCardClick()">
  <div card-header class="zag-open-shift-card__header">
    <!-- Colour bar -->
    <div class="zag-open-shift-card__color-bar" [style.background-color]="shift().shiftColor"></div>

    <!-- Title + time -->
    <div class="zag-open-shift-card__header-text">
      <h3 class="zag-open-shift-card__title">{{ shift().shiftName }}</h3>
      <span class="zag-open-shift-card__time">{{ shift().startTime }} – {{ shift().endTime }}</span>
    </div>

    <!-- Header action area: status badges or cancel icon -->
    <div class="zag-open-shift-card__action">
      @if (shift().type === 'swap' || shift().type === 'takeover') { @if (shift().hasPendingRequest) {
      <!-- Pending: show cancel icon button -->
      <button
        type="button"
        class="zag-open-shift-card__cancel-icon"
        [attr.aria-label]="'shiftSwaps.cancelRequest' | translate"
        (click)="onCancel($event)"
      >
        <span zagIcon="close"></span>
      </button>
      } @else if (!shift().eligible) {
      <span
        class="zag-open-shift-card__badge zag-open-shift-card__badge--ineligible"
        [zagTooltip]="ineligibilityTooltip()"
        tooltipPosition="below"
      >
        <span zagIcon="block"></span>
        <span class="zag-open-shift-card__badge-text">{{ 'shiftApplications.notEligible' | translate }}</span>
      </span>
      } } @else { @if (shift().alreadyApplied) {
      <span class="zag-open-shift-card__badge zag-open-shift-card__badge--applied">
        <span zagIcon="how_to_reg"></span>
        <span class="zag-open-shift-card__badge-text">{{ 'shiftApplications.alreadyAppliedBadge' | translate }}</span>
      </span>
      } @else if (shift().alreadyAssigned) {
      <span class="zag-open-shift-card__badge zag-open-shift-card__badge--assigned">
        <span zagIcon="check_circle"></span>
        <span class="zag-open-shift-card__badge-text">{{ 'shiftApplications.alreadyAssigned' | translate }}</span>
      </span>
      } @else if (!shift().eligible) {
      <span
        class="zag-open-shift-card__badge zag-open-shift-card__badge--ineligible"
        [zagTooltip]="ineligibilityTooltip()"
        tooltipPosition="below"
      >
        <span zagIcon="block"></span>
        <span class="zag-open-shift-card__badge-text">{{ 'shiftApplications.notEligible' | translate }}</span>
      </span>
      } }
    </div>
  </div>

  <!-- Body: info rows -->
  <div class="zag-open-shift-card__body">
    @if (isSwapType() && shift().assignedEmployeeName) {
    <div class="zag-open-shift-card__info-row">
      <span zagIcon="person" class="zag-open-shift-card__info-icon"></span>
      <span class="zag-open-shift-card__info-text">{{ shift().assignedEmployeeName }}</span>
    </div>
    }
    <div class="zag-open-shift-card__info-row">
      <span zagIcon="calendar_today" class="zag-open-shift-card__info-icon"></span>
      <span class="zag-open-shift-card__info-text">{{ shift().dateLabel }}</span>
    </div>
    <div class="zag-open-shift-card__info-row">
      <span zagIcon="group" class="zag-open-shift-card__info-icon"></span>
      <span class="zag-open-shift-card__info-text">{{ shift().teamName }}</span>
    </div>
    <div class="zag-open-shift-card__info-row">
      <span zagIcon="event_note" class="zag-open-shift-card__info-icon"></span>
      <span class="zag-open-shift-card__info-text">{{ shift().planName }}</span>
    </div>
    @if (!isSwapType()) {
    <div class="zag-open-shift-card__info-row">
      <span zagIcon="people" class="zag-open-shift-card__info-icon"></span>
      <span class="zag-open-shift-card__info-text zag-open-shift-card__slots">
        {{ 'shiftApplications.availableSlots' | translate: { count: shift().availableSlots } }}
      </span>
    </div>
    }
  </div>

  <!-- Footer: type label + ineligibility reasons -->
  @if (isSwapType()) {
  <div class="zag-open-shift-card__footer">
    <div class="zag-open-shift-card__type-badge">
      @if (shift().type === 'swap') {
      <span zagIcon="swap_horiz" class="zag-open-shift-card__type-icon zag-open-shift-card__type-icon--swap"></span>
      <span class="zag-open-shift-card__type-label zag-open-shift-card__type-label--swap">
        {{ 'shiftSwaps.typeLabelSwap' | translate }}
      </span>
      } @else {
      <span zagIcon="person_add" class="zag-open-shift-card__type-icon zag-open-shift-card__type-icon--takeover"></span>
      <span class="zag-open-shift-card__type-label zag-open-shift-card__type-label--takeover">
        {{ 'shiftSwaps.typeLabelTakeover' | translate }}
      </span>
      }
    </div>
  </div>
  } @else if (!shift().eligible && !shift().alreadyAssigned && !shift().alreadyApplied && shift().ineligibilityReasons.length > 0) {
  <div class="zag-open-shift-card__footer">
    <div class="zag-open-shift-card__reasons">
      @for (reason of shift().ineligibilityReasons; track reason) {
      <span class="zag-open-shift-card__reason">{{ 'shiftApplications.reasons.' + reason | translate }}</span>
      }
    </div>
  </div>
  }
</zag-card>
